export const isReferralAccountPersonalBusiness = (business) => Boolean(
  business &&
    business.type === 'personal' &&
    (business.accessFlags?.referralAccountPersonal === true || business.referralAccountPersonal === true)
);

const businessTypesWithTeamModeUpgradePath = new Set(['personal', 'business']);

export const canBusinessEnableTeamMode = (business) => Boolean(
  business &&
    businessTypesWithTeamModeUpgradePath.has(business.type) &&
    !isReferralAccountPersonalBusiness(business)
);

export const hasTeamModeAccess = (business) => {
  if (!business) return false;

  // The server is the authority. server/helpers/businessAccess.js also checks the
  // business-owned subscription's status and the founding-stylist referral rule,
  // and the client cannot see either field, so any payload that carries the
  // server's own answer wins outright. The derivation below is only the fallback
  // for payloads that do not carry it.
  if (typeof business.teamModeAccess === 'boolean') return business.teamModeAccess;

  return (
    canBusinessEnableTeamMode(business) &&
    business.accountMode === 'team' &&
    business.teamModeEnabled === true
  );
};
